import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft, Building2 } from "lucide-react";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function LegalNotice() {
  const { t } = useTranslation();
  return (
    <div className="relative min-h-screen hero-radial grain">
      <header className="relative z-30 flex items-center justify-between px-6 sm:px-10 py-5">
        <Link to="/" className="flex items-center gap-2 text-stone-300 hover:text-amber-200" data-testid="back-home">
          <ChevronLeft className="w-4 h-4" /> {t("common.back_home")}
        </Link>
        <div className="flex items-center gap-2 font-serif text-lg">
          <Building2 className="w-5 h-5 text-teal-300" /> {t("legal.notice_title")}
        </div>
        <LanguageSwitcher />
      </header>
      <main className="relative z-10 max-w-3xl mx-auto px-6 sm:px-10 pb-20 space-y-5 text-stone-200" data-testid="legal-notice-content">
        <h1 className="font-serif text-4xl font-black text-stone-50">{t("legal.notice_title")}</h1>
        <section className="space-y-2">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.notice_publisher_h")}</h2>
          <p>Chronos Time Puzzle</p>
          <p>{t("legal.notice_publisher_p")}</p>
        </section>
        <section className="space-y-2">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.notice_host_h")}</h2>
          <p>{t("legal.notice_host_p")}</p>
        </section>
        <section className="space-y-2">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.notice_contact_h")}</h2>
          <p><a href="mailto:hello@chronostimepuzzle.com" className="text-amber-300 hover:text-amber-200 underline" data-testid="notice-email">hello@chronostimepuzzle.com</a></p>
        </section>
        <section className="space-y-2">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.notice_ip_h")}</h2>
          <p>{t("legal.notice_ip_p")}</p>
        </section>
      </main>
    </div>
  );
}
